// Three.js ?쒓굅 - ?대?吏濡??泥?

import { DatabaseUtils } from './supabaseClient';
import { SecurityUtils } from './security-utils';
import { ErrorHandler, setupGlobalErrorHandling, handleAsyncError } from './error-handler';
import { startPerformanceMonitoring } from './performance-monitor';
import { analytics } from './analytics';
import { SimpleMarkdownParser } from './utils/markdown-parser';

// ?깅뒫 理쒖쟻?붾? ?꾪븳 ?곸닔??
const DEBOUNCE_DELAY = 250;

// ????뺤쓽
interface HeroData {
    title: {
        ko: string;
    };
    subtitle: {
        ko: string;
    };
}

interface PopupData {
    enabled: boolean;
    type: 'text' | 'image';
    content: {
        ko: string;
    };
    imageUrl?: string;
    startDate?: string;
    endDate?: string;
}

let heroData: HeroData | null = null;
let popupData: PopupData | null = null;
let aboutData: any = null;

// Enhanced caching with LRU implementation
class LRUCache {
    private cache = new Map<string, { data: any; timestamp: number; ttl: number }>();
    private maxSize = 50;
    
    get(key: string): any | null {
        const item = this.cache.get(key);
        if (!item) return null;
        
        if (Date.now() - item.timestamp > item.ttl) {
            this.cache.delete(key);
            return null;
        }
        
        // Move to end (most recently used)
        this.cache.delete(key);
        this.cache.set(key, item);
        return item.data;
    }
    
    set(key: string, data: any, ttl: number = 5 * 60 * 1000): void {
        // Remove oldest if at capacity
        if (this.cache.size >= this.maxSize && !this.cache.has(key)) {
            const firstKey = this.cache.keys().next().value;
            if (firstKey !== undefined) {
                this.cache.delete(firstKey);
            }
        }
        
        this.cache.set(key, { data, timestamp: Date.now(), ttl });
    }
    
    clear(): void {
        this.cache.clear();
    }
}

const dataCache = new LRUCache();
const CACHE_TTL = 5 * 60 * 1000; // 5遺?

// ?꾩뿭 ?먮윭 ?몃뱾???ㅼ젙
setupGlobalErrorHandling();

// ?깅뒫 紐⑤땲?곕쭅 ?쒖옉
startPerformanceMonitoring();

// 紐⑤컮???곗튂 ?쇰뱶諛??쒖뒪??珥덇린??
setupMobileTouchFeedback();

document.addEventListener('DOMContentLoaded', handleAsyncError(async () => {
    try {
        showLoadingState(true);
        
        // Track page view
        analytics.trackPageView(window.location.pathname, document.title);
        
        // 利됱떆 湲곕낯 ??댄븨 ?좊땲硫붿씠???쒖옉 (?곗씠??濡쒕뵫 ??
        startTypingAnimationWithDefaults();
        
        // ?곗씠?곕쿋?댁뒪 ?곌껐 ?곹깭 ?뺤씤
        try {
            // Supabase ?곌껐 ?뺤씤???꾪븳 媛꾨떒???붿껌
            await DatabaseUtils.checkConnection();
        } catch (error) {
            ErrorHandler.getInstance().showWarning('We could not connect to the database. Some features may be limited.');
        }
        
        // 蹂묐젹 ?곗씠??濡쒕뵫 with 媛쒕퀎 ?먮윭 泥섎━
        const [heroResult, popupResult, aboutResult] = await Promise.allSettled([
            loadHeroData(),
            loadPopupData(),
            loadAboutData()
        ]);
        
        // ?ㅽ뙣??濡쒕뵫 寃곌낵 泥섎━
        if (heroResult.status === 'rejected') {
            ErrorHandler.getInstance().handleError(heroResult.reason, 'Hero Data Loading');
        }
        if (popupResult.status === 'rejected') {
            ErrorHandler.getInstance().handleError(popupResult.reason, 'Popup Data Loading');
        }
        if (aboutResult.status === 'rejected') {
            ErrorHandler.getInstance().handleError(aboutResult.reason, 'About Data Loading');
        }
        
        setupEventListeners();
        setupScrollAnimations();
        // ?곗씠??濡쒕뱶 ?꾨즺 ???ㅼ젣 ?곗씠?곕줈 ??댄븨 ?낅뜲?댄듃
        if (heroData) {
            startTypingAnimation();
        }
        // About ?뱀뀡 ?뚮뜑留?
        if (aboutData) {
            renderAboutSection();
        }
        // Three.js ?쒓굅 - ?대?吏濡??泥대맖
        setupPopup();
        setupSliders();
        // Theme setup is handled by theme-toggle.js
    } catch (error) {
        ErrorHandler.getInstance().handleError(error as Error, 'Page Initialization');
    } finally {
        showLoadingState(false);
    }
}));

// 罹먯떆 ?좏떥由ы떚 ?⑥닔
function getCachedData(key: string): any | null {
    return dataCache.get(key);
}

function setCachedData(key: string, data: any, ttl: number = CACHE_TTL): void {
    dataCache.set(key, data, ttl);
}

async function loadAboutData() {
    const cacheKey = 'about-data';
    const cachedData = getCachedData(cacheKey); // Use default TTL
    
    if (cachedData) {
        console.log('✅ Using cached about data');
        aboutData = cachedData;
        return;
    }

    const defaultData = {
        title: 'Transparent discounts, verified partners, real savings.',
        content: `CoinPass is a referral-based crypto discount platform built by the Crypto DAO to make fee savings clear and fair.

Most exchanges share referral fees with promoters. CoinPass returns a meaningful portion of those fees to users so you can trade with lower costs.

If you find a better discount elsewhere, we encourage you to compare and verify. Our goal is to make promotions transparent and trustworthy.

We only list official partner programs and clearly explain what you receive. No hidden conditions or vague claims.

Join CoinPass today and start saving on every trade.`
    };

    try {
        console.log('Loading about data from database...');
        const data = await DatabaseUtils.getPageContent('about');
        
        if (data && data.content) {
            const content = typeof data.content === 'string' ? JSON.parse(data.content) : data.content;
            
            if (content) {
                aboutData = {
                    title: content.title || defaultData.title,
                    content: content.content || defaultData.content
                };
                console.log('??Successfully loaded about data from database');
            } else {
                aboutData = defaultData;
            }
            
            setCachedData(cacheKey, aboutData);
        } else {
            aboutData = defaultData;
        }
    } catch (error) {
        console.error('??Error loading about data:', error);
        aboutData = defaultData;
    }
}

async function loadHeroData() {
    const cacheKey = 'hero-data';
    // 캐시 임시 비활성화 (디버깅용)
    // const cached = getCachedData(cacheKey);
    // if (cached) {
    //     heroData = cached;
    //     return;
    // }

    const defaultData = {
        title: { ko: 'Save up to 50% on trading fees.' },
        subtitle: { ko: 'Verified partner discounts across top global exchanges.' }
    };

    try {
        console.log('Attempting to load hero data from database...');
        const data = await DatabaseUtils.getPageContent('hero');
        console.log('Raw data from DatabaseUtils.getPageContent:', data);
        
        if (data && data.content) {
            console.log('data.content type:', typeof data.content);
            console.log('data.content value:', data.content);
            
            // page_contents ?뚯씠釉붿쓽 content ?꾨뱶 援ъ“??留욊쾶 ?섏젙
            const content = typeof data.content === 'string' ? JSON.parse(data.content) : data.content;
            console.log('Parsed content:', content);
            console.log('content.title:', content?.title);
            console.log('content.subtitle:', content?.subtitle);
            
            // content?먮뒗 title怨?subtitle??吏곸젒 ?ㅼ뼱?덉쓬 (ko ?섑븨 ?놁쓬)
            if (content && content.subtitle) {
                heroData = {
                    title: { ko: content.title || defaultData.title.ko },
                    subtitle: { ko: content.subtitle }  // subtitle???덉쑝硫?諛섎뱶???ъ슜
                };
                console.log('??Successfully loaded hero data from database');
                console.log('??Database subtitle:', heroData.subtitle.ko);
            } else {
                console.log('?좑툘 Content missing subtitle, using defaults');
                heroData = defaultData;
            }
            
            setCachedData(cacheKey, heroData);
        } else {
            console.log('?좑툘 No data or no content field returned from database, using defaults');
            heroData = defaultData;
        }
    } catch (error) {
        console.error('??Error loading hero data:', error);
        heroData = defaultData;
    }
    
    console.log('=== Final heroData ===');
    console.log('Title:', heroData?.title?.ko);
    console.log('Subtitle:', heroData?.subtitle?.ko);
}

async function loadPopupData() {
    const cacheKey = 'popup-data';
    const cached = getCachedData(cacheKey);
    if (cached) {
        popupData = cached;
        return;
    }

    try {
        const data = await DatabaseUtils.getPageContent('popup');
        
        if (data) {
            // page_contents ?뚯씠釉붿쓽 content ?꾨뱶 援ъ“??留욊쾶 ?섏젙
            const content = typeof data.content === 'string' ? JSON.parse(data.content) : data.content;
            popupData = content;
            setCachedData(cacheKey, popupData);
        } else {
            popupData = null;
        }
    } catch (error) {
        console.error('Error loading popup data:', error);
        popupData = null;
    }
}

function setupEventListeners() {
    setupMobileMenu();
    
    // Track CTA button clicks
    document.querySelectorAll('.cta-button').forEach(button => {
        button.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            const buttonText = target.textContent || '';
            const href = target.getAttribute('href') || '';
            
            analytics.trackUserInteraction('cta_click', 'engagement', buttonText);
            
            if (href.includes('exchange')) {
                analytics.trackConversion('exchange_page_visit');
            }
        });
    });
    
    // Track calculator usage
    const calculatorInput = document.getElementById('trading-volume');
    if (calculatorInput) {
        calculatorInput.addEventListener('change', () => {
            analytics.trackUserInteraction('calculator_use', 'tools', 'savings_calculator');
        });
    }
}

class TypingAnimator {
    private el!: HTMLElement;
    private phrases!: string[];
    private loopNum: number = 0;
    private typingSpeed: number = 100;
    private erasingSpeed: number = 50;
    private delayBetweenPhrases: number = 2000;
    private isPaused: boolean = false;
    private timeoutId: number | null = null;

    constructor(el: HTMLElement, phrases: string[]) {
        if (!el || !phrases || phrases.length === 0) return;
        this.el = el;
        this.phrases = phrases;
        this.tick();
    }

    public setPhrases(phrases: string[]) {
        this.phrases = phrases;
        this.loopNum = 0;
        if(this.timeoutId) clearTimeout(this.timeoutId);
        this.el.textContent = '';
        if(!this.isPaused) this.tick();
    }

    private tick = async () => {
        if (this.isPaused || !this.el.isConnected) return;
        const i = this.loopNum % this.phrases.length;
        const fullTxt = this.phrases[i];
        
        // ??댄븨 ?좊땲硫붿씠??
        for (let j = 0; j < fullTxt.length; j++) {
            if (this.isPaused || !this.el.isConnected) return;
            this.el.textContent = fullTxt.substring(0, j + 1);
            await this.sleep(this.typingSpeed);
        }
        
        // ?꾩꽦???띿뒪?몃? 蹂댁뿬二쇰뒗 ?쒓컙
        await this.sleep(this.delayBetweenPhrases);
        
        // ??젣 ?좊땲硫붿씠??
        for (let j = fullTxt.length; j > 0; j--) {
            if (this.isPaused || !this.el.isConnected) return;
            this.el.textContent = fullTxt.substring(0, j - 1);
            await this.sleep(this.erasingSpeed);
        }
        
        // ?ㅼ쓬 臾멸뎄 ?쒖옉 ??吏㏃? ?湲?
        await this.sleep(500);
        
        this.loopNum++;
        this.timeoutId = window.setTimeout(this.tick, 0);
    }

    private sleep(ms: number): Promise<void> {
        return new Promise(resolve => { 
            this.timeoutId = window.setTimeout(resolve, ms); 
        });
    }
    
    public pause() { 
        this.isPaused = true; 
        if(this.timeoutId) clearTimeout(this.timeoutId); 
    }
    
    public resume() { 
        if(this.isPaused) { 
            this.isPaused = false; 
            this.tick(); 
        } 
    }
    
    public stop() {
        this.isPaused = true;
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
}

let typingAnimator: TypingAnimator | null = null;

// 利됱떆 湲곕낯媛믪쑝濡???댄븨 ?쒖옉
function startTypingAnimationWithDefaults() {
    const heroTitle = document.getElementById('hero-title');
    const heroSubtitle = document.getElementById('hero-subtitle');
    const heroSection = document.querySelector('.hero');
    if (!heroTitle) return;
    
    // 湲곗〈 ?좊땲硫붿씠?섏씠 ?덈떎硫??뺤?
    if (typingAnimator) {
        typingAnimator.stop();
        typingAnimator = null;
    }
    
    const defaultSentences = [
        'Save up to 50% on trading fees.',
        'Verified discounts from official partners.',
        'Join once and keep saving on every trade.'
    ];
    
    // subtitle??湲곕낯媛믪쑝濡??ㅼ젙 (?섏쨷???곗씠??濡쒕뱶?섎㈃ ??뼱?곌린??
    if (heroSubtitle) {
        heroSubtitle.textContent = 'Verified partner discounts across top global exchanges.';
    }
    
    typingAnimator = new TypingAnimator(heroTitle as HTMLElement, defaultSentences);
    
    // Intersection Observer濡?媛?쒖꽦???곕씪 ?좊땲硫붿씠???쒖뼱
    if(heroSection && typingAnimator){
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    typingAnimator?.resume();
                } else {
                    typingAnimator?.pause();
                }
            });
        }, { threshold: 0.1 });
        observer.observe(heroSection);
    }
}

function renderAboutSection() {
    if (!aboutData) return;
    
    const aboutSubtitleElement = document.getElementById('about-subtitle');
    const aboutContentElement = document.getElementById('about-content');
    
    if (aboutSubtitleElement && aboutData.title) {
        // subtitle??title濡??ъ슜 (?붿옄?몄긽 ?쇨???
        aboutSubtitleElement.innerHTML = `A fairer market starts with transparent incentives.`;
    }
    
    if (aboutContentElement && aboutData.content) {
        // 留덊겕?ㅼ슫 ?뚯떛 ?곸슜 (Bold? 留곹겕 吏??
        const parsedContent = SimpleMarkdownParser.parse(aboutData.content);
        aboutContentElement.innerHTML = parsedContent;
    }
    
    console.log('??About section rendered');
}

function startTypingAnimation() {
    const heroTitle = document.getElementById('hero-title');
    const heroSubtitle = document.getElementById('hero-subtitle');
    const heroSection = document.querySelector('.hero');
    
    console.log('?봽 startTypingAnimation called');
    console.log('?봽 heroData:', heroData);
    
    // subtitle???곗씠?곕쿋?댁뒪 媛믪쑝濡??낅뜲?댄듃 (heroData媛 ?덉쓣 ?뚮쭔)
    if (heroSubtitle) {
        if (heroData && heroData.subtitle && heroData.subtitle.ko) {
            console.log('??Updating subtitle with database value:', heroData.subtitle.ko);
            heroSubtitle.textContent = heroData.subtitle.ko;
        } else {
            console.log('?좑툘 No heroData.subtitle.ko available');
            console.log('Current heroData:', JSON.stringify(heroData, null, 2));
        }
    }
    
    if (!heroTitle || !heroData) {
        console.log('?좑툘 Missing heroTitle or heroData, exiting');
        return;
    }

    // 愿由ъ옄媛 ?ㅼ젙??臾몄옣???ъ슜, ?놁쑝硫?湲곕낯媛??ъ슜
    let sentences: string[] = [];
    
    if (heroData.title?.ko) {
        // 以꾨컮轅덉쑝濡?援щ텇???щ윭 臾몄옣??諛곗뿴濡?蹂??
        sentences = heroData.title.ko.split('\n')
            .map((line: string) => line.trim())
            .filter((line: string) => line.length > 0);
    }
    
    // 臾몄옣???놁쑝硫?湲곕낯媛??ъ슜
    if (sentences.length === 0) {
        sentences = [
            'Save up to 50% on trading fees.',
            'Verified discounts from official partners.',
            'Join once and keep saving on every trade.'
        ];
    }

    // 湲곗〈 ?좊땲硫붿씠?섏씠 ?덈떎硫???臾몄옣?쇰줈 ?낅뜲?댄듃
    if (typingAnimator) {
        typingAnimator.setPhrases(sentences);
    } else {
        typingAnimator = new TypingAnimator(heroTitle as HTMLElement, sentences);
        
        // Intersection Observer濡?媛?쒖꽦???곕씪 ?좊땲硫붿씠???쒖뼱
        if(heroSection && typingAnimator){
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        typingAnimator?.resume();
                    } else {
                        typingAnimator?.pause();
                    }
                });
            }, { threshold: 0.1 });
            observer.observe(heroSection);
        }
    }
    
    // subtitle ?낅뜲?댄듃???대? ?꾩뿉??泥섎━??
}




function setupScrollAnimations() {
    // Batch animation observations for better performance
    const animationQueue: Element[] = [];
    let rafId: number | null = null;
    
    const processAnimationQueue = () => {
        if (animationQueue.length === 0) {
            rafId = null;
            return;
        }
        
        // Process up to 5 elements per frame
        const batch = animationQueue.splice(0, 5);
        batch.forEach(element => {
            element.classList.add('is-visible');
        });
        
        rafId = requestAnimationFrame(processAnimationQueue);
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animationQueue.push(entry.target);
                observer.unobserve(entry.target);
                
                if (!rafId) {
                    rafId = requestAnimationFrame(processAnimationQueue);
                }
            }
        });
    }, { 
        threshold: 0.1,
        rootMargin: '50px' // Start loading slightly before element is visible
    });
    
    // Use querySelectorAll more efficiently
    const elements = document.querySelectorAll('.anim-fade-in');
    elements.forEach(el => observer.observe(el));
}

function setupMobileMenu() {
    const hamburgerButton = document.querySelector('.hamburger-button') as HTMLButtonElement;
    const mainNav = document.getElementById('main-nav');
    
    if (!hamburgerButton || !mainNav) {
        console.warn('Hamburger menu elements not found');
        return;
    }
    
    // Toggle menu on hamburger click
    hamburgerButton.addEventListener('click', function() {
        const isActive = hamburgerButton.classList.contains('is-active');
        
        if (isActive) {
            // Close menu
            hamburgerButton.classList.remove('is-active');
            hamburgerButton.setAttribute('aria-expanded', 'false');
            mainNav.classList.remove('active');
            document.body.style.overflow = '';
        } else {
            // Open menu
            hamburgerButton.classList.add('is-active');
            hamburgerButton.setAttribute('aria-expanded', 'true');
            mainNav.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    });
    
    // Close menu when clicking outside
    document.addEventListener('click', function(event) {
        const target = event.target as HTMLElement;
        if (!hamburgerButton.contains(target) && !mainNav.contains(target)) {
            if (hamburgerButton.classList.contains('is-active')) {
                hamburgerButton.classList.remove('is-active');
                hamburgerButton.setAttribute('aria-expanded', 'false');
                mainNav.classList.remove('active');
                document.body.style.overflow = '';
            }
        }
    });
    
    // Close menu on escape key
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && hamburgerButton.classList.contains('is-active')) {
            hamburgerButton.classList.remove('is-active');
            hamburgerButton.setAttribute('aria-expanded', 'false');
            mainNav.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
    
    // Handle window resize
    window.addEventListener('resize', function() {
        if (window.innerWidth > 768 && hamburgerButton.classList.contains('is-active')) {
            hamburgerButton.classList.remove('is-active');
            hamburgerButton.setAttribute('aria-expanded', 'false');
            mainNav.classList.remove('active');
            document.body.style.overflow = '';
        }
    });
    
    // Close menu when clicking nav links
    mainNav.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => {
            hamburgerButton.classList.remove('is-active');
            mainNav.classList.remove('active');
            hamburgerButton.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        });
    });
}

// Three.js 愿??肄붾뱶 ?쒓굅 - ?대?吏濡??泥대맖

// Three.js 愿??肄붾뱶 紐⑤몢 ?쒓굅 - ?뺤쟻 ?대?吏濡??泥대맖

function setupPopup() {
    if (!popupData || !popupData.enabled) return;
    
    const hideUntil = localStorage.getItem('coinpass-index-popup-hide-until');
    if (hideUntil && Date.now() < parseInt(hideUntil, 10)) return;

    const now = new Date();
    const startDate = popupData.startDate ? new Date(popupData.startDate) : null;
    const endDate = popupData.endDate ? new Date(popupData.endDate) : null;
    if ((startDate && now < startDate) || (endDate && now > endDate)) return;

    const container = document.getElementById('popup-container');
    const imageEl = document.getElementById('popup-image');
    const textEl = document.getElementById('popup-text');
    const closeBtn = document.getElementById('popup-close');
    const close24hBtn = document.getElementById('popup-close-24h');
    const overlay = container?.querySelector('.popup-overlay');
    if (!container || !imageEl || !textEl || !closeBtn || !close24hBtn) return;
    
    const contentToDisplay = popupData.content ? popupData.content.ko : '';

    if (popupData.type === 'image' && popupData.imageUrl) {
        (imageEl as HTMLImageElement).src = popupData.imageUrl;
        (imageEl as HTMLElement).style.display = 'block';
        (textEl as HTMLElement).style.display = 'none';
    } else if (popupData.type === 'text' && contentToDisplay) {
        textEl.textContent = SecurityUtils.sanitizeHtml(contentToDisplay);
        (textEl as HTMLElement).style.display = 'block';
        (imageEl as HTMLElement).style.display = 'none';
    } else return;
    
    container.style.display = 'flex';
    const closePopup = () => container.style.display = 'none';
    closeBtn.onclick = closePopup;
    if(overlay) overlay.addEventListener('click', closePopup);
    close24hBtn.onclick = () => {
        localStorage.setItem('coinpass-index-popup-hide-until', (Date.now() + 24 * 60 * 60 * 1000).toString());
        closePopup();
    };
}

class CardSlider {
    private container: HTMLElement;
    private grid!: HTMLElement;
    private prevBtn!: HTMLElement;
    private nextBtn!: HTMLElement;
    private dots!: NodeListOf<HTMLElement>;
    private cards!: NodeListOf<HTMLElement>;
    private currentSlide: number = 0;
    private maxSlides!: number;
    private cardsPerSlide: number = 3;

    constructor(containerSelector: string) {
        this.container = document.querySelector(containerSelector)!;
        if (!this.container) return;

        this.grid = this.container.querySelector('.features-grid, .benefits-grid')!;
        this.prevBtn = this.container.querySelector('.slider-nav.prev')!;
        this.nextBtn = this.container.querySelector('.slider-nav.next')!;
        this.dots = this.container.querySelectorAll('.dot');
        this.cards = this.grid.querySelectorAll('.feature-card, .benefit-item');
        
        this.maxSlides = Math.ceil(this.cards.length / this.cardsPerSlide);
        
        this.setupEventListeners();
        this.updateSlider();
        this.updateDots();
    }

    private setupEventListeners() {
        this.prevBtn?.addEventListener('click', () => this.prevSlide());
        this.nextBtn?.addEventListener('click', () => this.nextSlide());
        
        this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.goToSlide(index));
        });

        // Touch/swipe support
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let currentY = 0;

        this.grid.addEventListener('touchstart', (e) => {
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        });

        this.grid.addEventListener('touchmove', (e) => {
            e.preventDefault();
            currentX = e.touches[0].clientX;
            currentY = e.touches[0].clientY;
        });

        this.grid.addEventListener('touchend', () => {
            const deltaX = startX - currentX;
            const deltaY = Math.abs(startY - currentY);
            
            // Only if horizontal swipe is more significant than vertical
            if (Math.abs(deltaX) > deltaY && Math.abs(deltaX) > 50) {
                if (deltaX > 0) {
                    this.nextSlide();
                } else {
                    this.prevSlide();
                }
            }
        });
    }

    private prevSlide() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
            this.updateSlider();
            this.updateDots();
        }
    }

    private nextSlide() {
        if (this.currentSlide < this.maxSlides - 1) {
            this.currentSlide++;
            this.updateSlider();
            this.updateDots();
        }
    }

    private goToSlide(slideIndex: number) {
        if (slideIndex >= 0 && slideIndex < this.maxSlides) {
            this.currentSlide = slideIndex;
            this.updateSlider();
            this.updateDots();
        }
    }

    private updateSlider() {
        const translateX = -(this.currentSlide * 100);
        this.grid.style.transform = `translateX(${translateX}%)`;
        
        // Update navigation buttons
        if (this.prevBtn) {
            this.prevBtn.style.display = this.currentSlide === 0 ? 'none' : 'flex';
        }
        if (this.nextBtn) {
            this.nextBtn.style.display = this.currentSlide === this.maxSlides - 1 ? 'none' : 'flex';
        }
    }

    private updateDots() {
        this.dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === this.currentSlide);
        });
    }
}

function setupSliders() {
    // Setup sliders based on screen size
    const setupSlidersForCurrentSize = () => {
        const width = window.innerWidth;
        if (width > 768) {
            // Desktop and tablet get sliders
            new CardSlider('.why-coinpass .slider-container');
        } else {
            // Mobile: reset transforms
            const grids = document.querySelectorAll('.benefits-grid');
            grids.forEach(grid => {
                (grid as HTMLElement).style.transform = 'translateX(0)';
            });
        }
    };

    setupSlidersForCurrentSize();
    
    // Handle window resize with debouncing
    let resizeTimeout: number;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
            setupSlidersForCurrentSize();
        }, DEBOUNCE_DELAY);
    });
}

// ?좏떥由ы떚 ?⑥닔??

function showLoadingState(show: boolean) {
    const existingLoader = document.getElementById('page-loader');
    
    if (show && !existingLoader) {
        const loader = document.createElement('div');
        loader.id = 'page-loader';
        loader.innerHTML = `
            <div class="loader-backdrop">
                <div class="loader-spinner">
                    <div class="spinner"></div>
                    <p>Loading...</p>
                </div>
            </div>
        `;
        loader.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 9999;
            display: flex;
            align-items: center;
            justify-content: center;
        `;
        
        const style = document.createElement('style');
        style.textContent = `
            .loader-backdrop {
                background: rgba(0, 0, 0, 0.8);
                border-radius: 12px;
                padding: 2rem;
                text-align: center;
            }
            .loader-spinner {
                color: white;
            }
            .spinner {
                width: 40px;
                height: 40px;
                border: 4px solid rgba(255,255,255,0.3);
                border-left: 4px solid #00d4aa;
                border-radius: 50%;
                animation: spin 1s linear infinite;
                margin: 0 auto 1rem;
            }
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            @keyframes slideIn {
                from { transform: translateX(100%); opacity: 0; }
                to { transform: translateX(0); opacity: 1; }
            }
            @keyframes slideOut {
                to { transform: translateX(100%); opacity: 0; }
            }
        `;
        document.head.appendChild(style);
        document.body.appendChild(loader);
        
    } else if (!show && existingLoader) {
        existingLoader.style.opacity = '0';
        setTimeout(() => {
            if (existingLoader.parentNode) {
                document.body.removeChild(existingLoader);
            }
        }, 300);
    }
}

// Theme Management (delegated to theme-toggle.js for consistency)

// 紐⑤컮???곗튂 ?쇰뱶諛??쒖뒪??
function setupMobileTouchFeedback() {
    // ?곗튂 ?쇰뱶諛깆쓣 ?꾪븳 CSS ?ㅽ????숈쟻 異붽?
    const touchStyles = document.createElement('style');
    touchStyles.textContent = `
        .touch-feedback {
            position: relative;
            overflow: hidden;
        }
        
        .touch-feedback::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(0, 212, 170, 0.3);
            transform: translate(-50%, -50%);
            transition: width 0.6s, height 0.6s;
            pointer-events: none;
            z-index: 1;
        }
        
        .touch-feedback.touch-active::before {
            width: 300px;
            height: 300px;
        }
        
        .touch-ripple {
            position: absolute;
            border-radius: 50%;
            background: rgba(0, 212, 170, 0.4);
            transform: scale(0);
            animation: ripple 0.6s linear;
            pointer-events: none;
        }
        
        @keyframes ripple {
            to {
                transform: scale(4);
                opacity: 0;
            }
        }
        
        /* ?낇떛 ?쇰뱶諛깆쓣 ?꾪븳 誘몄꽭??吏꾨룞 ?④낵 */
        .haptic-feedback:active {
            transform: scale(0.98);
            filter: brightness(1.1);
        }
    `;
    document.head.appendChild(touchStyles);

    // ?곗튂 媛?ν븳 ?붿냼??媛먯? 諛??쇰뱶諛?異붽?
    const touchableSelectors = [
        'button',
        '.cta-button',
        '.card-cta',
        '.hamburger-button',
        '#theme-toggle',
        '.nav-link',
        '.feature-link',
        '.slider-nav',
        '.dot',
        '.popup-actions button'
    ];

    // DOMContentLoaded ?대깽?몃? 湲곕떎由ъ? ?딄퀬 諛붾줈 ?ㅽ뻾 (?대? DOMContentLoaded ?댁뿉???몄텧??
    touchableSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            setupElementTouchFeedback(element as HTMLElement);
        });
    });

    // ?숈쟻?쇰줈 ?앹꽦?섎뒗 ?붿냼瑜??꾪븳 ?대깽???꾩엫
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });
}

function setupElementTouchFeedback(element: HTMLElement) {
    if (!element) return;
    
    element.classList.add('touch-feedback', 'haptic-feedback');
    
    element.addEventListener('touchstart', (e) => {
        createRippleEffect(e, element);
        // 吏꾨룞 ?쇰뱶諛?(吏?먮릺??湲곌린?먯꽌)
        if (navigator.vibrate) {
            navigator.vibrate(10);
        }
    });
}

function createRippleEffect(event: TouchEvent, element: HTMLElement) {
    const rect = element.getBoundingClientRect();
    const ripple = document.createElement('div');
    const size = Math.max(rect.width, rect.height);
    const touch = event.touches[0];
    
    if (!touch) return;
    
    const x = touch.clientX - rect.left - size / 2;
    const y = touch.clientY - rect.top - size / 2;
    
    ripple.classList.add('touch-ripple');
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = x + 'px';
    ripple.style.top = y + 'px';
    
    element.appendChild(ripple);
    
    // ?좊땲硫붿씠?????쒓굅
    setTimeout(() => {
        if (ripple.parentNode) {
            ripple.parentNode.removeChild(ripple);
        }
    }, 600);
}

function handleTouchStart(event: TouchEvent) {
    const target = event.target as HTMLElement;
    if (target && isTouchableElement(target)) {
        target.classList.add('touch-active');
    }
}

function handleTouchEnd(event: TouchEvent) {
    const target = event.target as HTMLElement;
    if (target && isTouchableElement(target)) {
        setTimeout(() => {
            target.classList.remove('touch-active');
        }, 150);
    }
}

function isTouchableElement(element: HTMLElement): boolean {
    const touchableTypes = ['BUTTON', 'A', 'INPUT'];
    const touchableClasses = ['cta-button', 'card-cta', 'hamburger-button', 'clickable'];
    
    return touchableTypes.includes(element.tagName) || 
           touchableClasses.some(className => element.classList.contains(className)) ||
           element.hasAttribute('role') && ['button', 'link'].includes(element.getAttribute('role') || '');
}

// 紐⑤컮???꾩슜 ?쒖뒪泥?吏??
function setupMobileGestures() {
    let touchStartX = 0;
    let touchStartY = 0;
    
    document.addEventListener('touchstart', (e) => {
        const touch = e.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
    }, { passive: true });
    
    document.addEventListener('touchend', (e) => {
        if (!e.changedTouches[0]) return;
        
        const touch = e.changedTouches[0];
        const touchEndX = touch.clientX;
        const touchEndY = touch.clientY;
        
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;
        
        // ?ㅼ??댄봽 媛먯? (理쒖냼 50px ?대룞)
        if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
            if (deltaX > 0) {
                // ?ㅻⅨ履??ㅼ??댄봽
                handleSwipeRight();
            } else {
                // ?쇱そ ?ㅼ??댄봽
                handleSwipeLeft();
            }
        }
    }, { passive: true });
}

function handleSwipeRight() {
    // 紐⑤컮??硫붾돱媛 ?대젮?덉쑝硫??リ린
    const nav = document.getElementById('main-nav');
    const hamburger = document.querySelector('.hamburger-button');
    
    if (nav?.classList.contains('is-active')) {
        nav.classList.remove('is-active');
        hamburger?.classList.remove('is-active');
    }
    
    // ?앹뾽???대젮?덉쑝硫??リ린
    const popup = document.getElementById('popup-container');
    if (popup && popup.style.display !== 'none') {
        popup.style.display = 'none';
    }
}

function handleSwipeLeft() {
    // ?쇱そ ?ㅼ??댄봽 ?숈옉 (?꾩슂??援ы쁽)
    // Left swipe detected
}

// 紐⑤컮???쒖뒪泥?珥덇린??
setupMobileGestures();

